import React, {useContext, useEffect, useState, useRef} from 'react';
import FindingComment from './FindingComment';
import InfiniteScroll from 'react-infinite-scroll-component';

import uniqid from 'uniqid';
import {getAllRemarks, getAudits} from '../../../../../services/findings';
import Loader from '../../../../../components/loader/Loader';
import {useParams} from 'react-router-dom';
import {t} from 'react-switch-lang';
import {Empty} from 'antd';

const FindingCommentsList = ({resetList}) => {
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [comments, setComments] = useState([]);
  const [dataIsLoaded, setDataIsLoaded] = useState(false);
  const listId = uniqid();
  const params = useParams();

  const fetchData = () => {
    setHasMore(true);
    setPageNumber(0);

    getAllRemarks(params.findingId, 0)
      .then((r) => {
        setDataIsLoaded(true);
        onFetchSuccess(r);
      })
      .catch((r) => {
        setDataIsLoaded(true);
      });
  };

  const onFetchSuccess = (r) => {
    if (r.data.length !== 0) {
      setComments(r.data);
      setPageNumber(1);
    } else {
      setComments(r.data);
      setHasMore(false);
    }
  };

  const onFetchMoreSuccess = (r) => {
    if (r.data.length !== 0) {
      const newData = comments;
      r.data.map((item) => newData.push(item));
      setComments(newData);
      setPageNumber(pageNumber + 1);
    } else {
      setHasMore(false);
    }
  };

  const fetchMoreData = () => {
    getAllRemarks(params.findingId, pageNumber)
      .then((r) => onFetchMoreSuccess(r))
      .catch((r) => {});
  };

  useEffect(() => {
    fetchData();
  }, [resetList]);

  return (
    <div
      style={{top: '-14px', padding: '0'}}
      className="remarks-document-comments-list"
      id={listId}
    >
      {comments?.length > 0 ? (
        <InfiniteScroll
          dataLength={comments.length}
          next={fetchMoreData}
          hasMore={hasMore}
          scrollableTarget={listId}
          scrollThreshold={0.7}
          loader={<Loader />}
        >
          {comments.map((comment) => {
            return <FindingComment comment={comment} key={uniqid()} />;
          })}
        </InfiniteScroll>
      ) : (
        dataIsLoaded && (
          <Empty
            description={t('common.noData')}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        )
      )}
    </div>
  );
};

export default FindingCommentsList;
